import React, { useState } from "react";
import { Card, CardBody, CardHeader, Col, Nav, NavItem, NavLink } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BohoProfilesForNewEmployees, Href, IOTDeveloper, JustifyTab, UxDesigner, WebDesigner } from "../../../../Constant";
import { JUSTIFY_TABS_DATA } from "../../../../Data/UiKit/Tabs";
import { P } from "../../../../AbstractElements";
import { JustifytabContent } from "./JustifytabContent";

const JustifyTabs = () => {
  const [basicTab, setBasicTab] = useState("2");
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={JustifyTab} span={JUSTIFY_TABS_DATA} />
        <CardBody>
          <CardHeader className="d-flex justify-content-between align-items-center flex-wrap gap-2 pb-2 p-0">
            <P><em className="txt-danger">{BohoProfilesForNewEmployees}</em></P>
            <Nav pills className="nav-warning">
              <NavItem><NavLink href={Href} className={basicTab === "1" ? "active" : ""} onClick={() => setBasicTab("1")}>{WebDesigner}</NavLink></NavItem>
              <NavItem><NavLink href={Href} className={basicTab === "2" ? "active" : ""} onClick={() => setBasicTab("2")}>{UxDesigner}</NavLink></NavItem>
              <NavItem><NavLink href={Href} className={basicTab === "3" ? "active" : ""} onClick={() => setBasicTab("3")}>{IOTDeveloper}</NavLink></NavItem>
            </Nav>
          </CardHeader>
            <JustifytabContent basicTab={basicTab}/>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JustifyTabs;
